import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-372183e1"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(_ctx.value2label(_ctx.questionTypeId, _ctx.QUESTION_TYPE)), 1), _createElementVNode("span", _hoisted_2, " 第" + _toDisplayString(_ctx.index) + "题/共" + _toDisplayString(_ctx.totalNum) + "题 合计" + _toDisplayString(_ctx.totalScore) + "分 ", 1)]);
}